import Table from '@missionlabs/smartagent-app-components/dist/Table';

import React, { useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { IContactSearchForm } from 'store/contactSearch/contactSearch.types';
import { setSelectedInteraction } from 'store/contactSearch/contactSearch.actions';

import { IInteraction } from '../types';
import { allTableColumns } from './columns';

import searchIcon from 'images/search.svg';

import './contact-search-results.scss';

export interface Props {
    interactions: IInteraction[];
    channel: IContactSearchForm['channel'];
}

const ContactSearchResults: React.FC<Props> = ({ interactions, channel }) => {
    const dispatch = useDispatch();

    const tableColumns = useMemo(() => allTableColumns[channel.group], [interactions]);

    return (
        <section className="contact-search-results">
            <Table
                sort="initiationTimestamp"
                sortBy="descending"
                pagination
                rowsPerPage={30}
                selectable
                onSelect={(interaction: IInteraction) => dispatch(setSelectedInteraction(interaction))}
                cols={tableColumns}
                data={interactions}
                noData={
                    <div className="row column auto">
                        <div>
                            <img src={searchIcon} height="24" width="24" alt="No data" title="No data" />
                            <p>
                                There are no records to view. Use the <br />
                                search to retrieve contacts
                            </p>
                        </div>
                    </div>
                }
            />
        </section>
    );
};

export default ContactSearchResults;
